import { z } from 'zod';

import { unique } from '@vestigas/utils';

import { zodTaxCodeSchema } from '../validations';

const zodCanonicalStringArraySchema = z
  .array(z.string())
  .optional()
  .catch(undefined)
  .transform((values) =>
    values ? unique(values).filter(Boolean).toSorted() : values,
  );

export const taxCodesOrderByValues = [
  'company_name',
  'name',
  'rate',
  'code',
  'is_reverse_charge',
  'created_on',
  'updated_on',
] as const;

export const zodTaxCodesOrderBySchema = z.enum(taxCodesOrderByValues);

export const zodTaxCodesSortOrderSchema = z.enum(['ASC', 'DESC']);

export const zodTaxCodesQueryParamsSchema = z.object({
  codes: zodCanonicalStringArraySchema,
  companyIds: z
    .array(z.uuid())
    .optional()
    .catch(undefined)
    .transform((values) =>
      values ? unique(values).filter(Boolean).toSorted() : values,
    ),
  isReverseCharge: z.boolean().optional().catch(undefined),
  limit: z.number().int().min(1).max(500).default(50),
  names: zodCanonicalStringArraySchema,
  offset: z.number().int().min(0).default(0),
  orderBy: zodTaxCodesOrderBySchema.optional(),
  rates: zodCanonicalStringArraySchema,
  searchString: z.string().trim().optional(),
  sortOrder: zodTaxCodesSortOrderSchema.optional(),
});

export const zodTaxCodesResponseSchema = z.object({
  data: z.array(zodTaxCodeSchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative().nullable(),
});
